/* sb-dc-fonts.js — more typefaces in the text panel.

   The app shipped with six (Anton, Archivo, Oswald, Bebas Neue, Montserrat,
   Noto Sans KR), which is thin for signage: no script, no serif, no slab.
   The list lives in the 647KB app bundle, so the extra families are added to
   the <select> from here instead of rebuilding that file.

   APPEND ONLY — THIS IS NOT A STYLE PREFERENCE.
   The first version of this file cleared the select and rebuilt every option
   from scratch. That deletes nodes React created, so the next time React
   re-rendered it tried to remove children that were no longer there and threw
   "removeChild: The node to be removed is not a child of this node", which
   unmounted the whole editor and left a blank page. React's own six options
   are therefore left exactly where they are and the new ones are appended
   after them. Adding siblings React does not own is safe; removing its nodes
   is not.

   Second thing that makes this more than an <option> dump: CANVAS FONTS MUST
   BE LOADED BEFORE THEY DRAW. Konva paints text onto a canvas, and a canvas
   does not wait for a webfont the way HTML does — it silently draws in a
   fallback and never repaints. So a family is passed to document.fonts.load()
   and the layer is only re-applied once that promise resolves. Without this a
   customer picks Pacifico, sees Arial, and that fallback is what gets
   printed. */
(function () {
  'use strict';

  /* Families the bundle already offers — never re-added, never touched. */
  var BUILT_IN = ['Anton', 'Archivo', 'Oswald', 'Bebas Neue', 'Montserrat', 'Noto Sans KR'];

  var GROUPS = [
    ['Bold & display', ['Archivo Black', 'Alfa Slab One', 'Abril Fatface', 'Bungee',
                        'Staatliches', 'Fjalla One', 'Teko', 'Russo One']],
    ['Sans serif',     ['Poppins', 'Inter', 'Roboto', 'Open Sans', 'Lato',
                        'Raleway', 'Nunito', 'Barlow Condensed']],
    ['Serif',          ['Playfair Display', 'Merriweather', 'Lora', 'Bitter']],
    ['Script & hand',  ['Pacifico', 'Lobster', 'Dancing Script', 'Great Vibes',
                        'Caveat', 'Permanent Marker']],
    ['Korean',         ['Black Han Sans', 'Do Hyeon', 'Jua']]
  ];

  var ADDED = [];
  GROUPS.forEach(function (g) { ADDED = ADDED.concat(g[1]); });
  var ALL = BUILT_IN.concat(ADDED);

  /* ------------------------------------------------------------ loading */
  var loaded = {};
  function ensure(family) {
    if (loaded[family]) return loaded[family];
    var p;
    try {
      if (!document.fonts || !document.fonts.load) {
        p = Promise.resolve();
      } else {
        // both weights: the app draws bold text by default
        p = Promise.all([
          document.fonts.load('400 32px "' + family + '"'),
          document.fonts.load('700 32px "' + family + '"')
        ]);
      }
    } catch (e) { p = Promise.resolve(); }
    loaded[family] = p;
    return p;
  }

  /* Konva has already painted with the fallback by the time the font lands,
     and nothing tells it to repaint. Re-applying the same fontFamily is the
     cheapest honest nudge — it goes through the app's own update path, so the
     text is re-measured and re-fitted with the real metrics. */
  function repaint(layerId, family) {
    try {
      var a = window.__dcApi;
      if (!a || !layerId) return;
      a.updateLayer(layerId, { fontFamily: family });
    } catch (e) {}
  }

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('fb-font')) return;
    var family = sel.value;
    if (!family) return;
    var a = window.__dcApi;
    var id = a && a.selectedId;
    ensure(family).then(function () { repaint(id, family); });
  }, true);

  /* ------------------------------------------------------------- options */
  function add(sel) {
    if (sel.querySelector('optgroup[data-sb-fonts]')) return;   // already appended
    GROUPS.forEach(function (g) {
      var og = document.createElement('optgroup');
      og.label = g[0];
      og.setAttribute('data-sb-fonts', '1');
      g[1].forEach(function (f) {
        var o = document.createElement('option');
        o.value = f;
        o.textContent = f;
        o.style.fontFamily = '"' + f + '", sans-serif';   // show each in its own face
        og.appendChild(o);
      });
      sel.appendChild(og);                                 // after React's own options
    });
  }

  function scan() {
    document.querySelectorAll('select.fb-font').forEach(add);
  }

  if (typeof MutationObserver === 'function') {
    var pend = 0;
    var mo = new MutationObserver(function () {
      if (pend) return;
      pend = setTimeout(function () { pend = 0; try { scan(); } catch (e) {} }, 80);
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () {
      try { mo.disconnect(); } catch (e) {}
      if (pend) { clearTimeout(pend); pend = 0; }
    });
  }
  scan();

  /* Warm the added set once the page is idle, so the dropdown previews and
     any template using one of these are right the first time they are seen. */
  function warm() { ADDED.forEach(ensure); }
  /* V0.1.2 (2026-09-09): 기본 6종은 «미루지 않고» 바로 받는다. 구글 글꼴은 쓰이기 전까지 안 받아지는데,
     변환기(sb-dc-aug.js curveFromPath)가 곡선 각도를 «글자 폭 ÷ 반지름» 으로 재므로 대체 글꼴로 재면
     각도가 부푼다(Oswald 대체 폭 219 vs 진짜 177 → 타원 100° vs 81°). 템플릿 SVG 를 받는 동안 글꼴이 먼저 온다. */
  try { BUILT_IN.forEach(ensure); } catch (e) {}
  if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 4000 });
  else setTimeout(warm, 2500);

  window.__dcFonts = ALL;                     // test hooks
  window.__dcAddedFonts = ADDED;
  window.__dcEnsureFont = ensure;
})();
